<template>
  <div class="about">
    <div class="about-banner">
      <img :src="img ? fileUrl+img : defaultImg" alt="">
      <div class="about-banner-title">
        <div>{{banner.title}}</div> 
        <div>{{banner.description}}</div>
      </div>
    </div> 
    <div class="about-introduce">
      <div>公司简介</div>
      <div>
        <div v-for="(item,index) in introduce" :key="index">{{item}}</div> 
      </div>
    </div>
    <div class="about-culture">
      <div class="about-culture-title"><div>企业文化</div></div>
      <div class="about-culture-content">
        <div v-for="(item,index) in culture" :key="index">
          <img :src="item.url" alt="">
          <div class="title">{{item.name}}</div>
          <div class="info">{{item.content}}</div>
        </div>
      </div>      
    </div>
    <div class="about-advantage">
      <div class="about-advantage-title"><div>公司优势</div></div>
      <div class="about-advantage-content">
        <div v-for="(item,index) in advantage" :key="index" @click="current=item.id" :class="{active:current == item.id}">
          <div>{{item.name}}</div>
          <div>
            <div v-for="(v,k) in item.content" :key="k">{{v}}</div> 
          </div>
        </div>
      </div>
    </div>
    <div class="about-map">
      <img src="../assets/img/about_map.png" alt="">
      <div class="about-map-location">
        <img src="../assets/img/about_location.png" alt="">
        <div>公司地址：苏州市工业园区园科大厦3楼</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState} from 'vuex'
import * as API from '../api/api'
export default {
  data(){
    return{
      defaultImg:require('../assets/img/about_banner.png'),
      banner:[],
      current:0,
      img:'',
      introduce:[
        '苏州吉埃思数据信息科技有限公司成立于2019年，位于苏州工业园区创意产业园，是一家具有独立软件开发能力的科技型公司。',
        '主营软件APP、小程序、PC端开发及地理信息数据采集服务。现已与几十家企事业单位达成合作，携手开发了“数字乡村”“管线管理”“农房信息管理”“征迁管理”等一系列数字化系统，为乡村振兴、城市智慧化管理以及社会经济建设提供有力支持。',
        '在党和国家政策的支持下，我司业务已得到进一步拓展，同时我司也将继续承担自身社会责任，以业务优势，助推社会与企业数字化建设转型，提升客户工作向高效化、科学化、智能化方向转变。'],
      culture:[
        {
          name:'价值观',
          content:'客户为先、创新突破、融合进取、诚信担当',
          url:require('../assets/img/about_culture1.png')
        },
        {
          name:'愿景',
          content:'紧跟行业发展方向，时刻走在行业前沿',
          url:require('../assets/img/about_culture2.png')
        },
        {
          name:'使命',
          content:'用科技力量为客户创造更多价值',
          url:require('../assets/img/about_culture3.png')
        },
      ],
      advantage:[
        {
          id:0,
          name:'专业度高',
          content:[
            '拥有专门的软件自主研发团队，团队成员均具备高素质、高学历；',
            '配备先进的数据采集设备与数据处理软件；',
            '掌握成熟的三维实景建模等技术。']
        },
         {
           id:1,
          name:'安全可靠',
          content:['我司所开发的系统可依据客户实际需求设置不同权限分配，保障客户数据安全。']
        },
         {
           id:2,
          name:'经验丰富',
          content:['成立至今公司已承接大小几十起软件开发项目，涉及数字乡村、城市管理等多个方向，能够应对不同项目需求。']
        },
         {
           id:3,
          name:'售后无忧',
          content:['支持本地化部署；','专业团队持续给予系统使用指导及系统维护服务。']
        },
      ]
    
    }
  },
  computed: {
    ...mapState({fileUrl:state => state.fileUrl})
  },
  mounted(){
    this.getBanner()
  },
  methods:{
    getBanner(){
      let that=this
      API.getBanner(3).then(res=>{
        // console.log(res.data);
        that.banner=res.data
        that.img= res.data.imgs.length>0 ? res.data.imgs[0]:''
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .about{
    &-banner{
      width: 100%;
      height: 4.4rem;
      position: relative;
      >img{
        width: 100%;
        height: 100%;
      }
      &-title{
        position: absolute;
        left: 0;
        right: 0;
        top:1.8rem;
        margin: auto;
        font-size: 0.38rem;
        color: #CAD4E1;
        text-align: center;
        >div:nth-child(1){
          letter-spacing: 0.1rem;
        }
        >div:nth-child(2){
          font-size: 0.18rem;
          letter-spacing: 0.05rem;
          margin-top: 0.3rem;
        }
      }
    }
    &-introduce{
      width: 12rem;
      height: 5.7rem;
      margin:0.85rem auto;
      background: url('../assets/img/about_introduce.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      >div:nth-child(1){
        color: #fff;
        font-size: 0.38rem;
        letter-spacing: 8px;
        padding-top: 1.1rem;
        margin-left: 0.5rem;
      }
      >div:nth-child(2){
        width: 10rem;
        margin:0.36rem auto;
        color: #fff;
        font-size: 0.22rem;
        line-height: 0.35rem;
        >div{
          text-indent: 0.45rem;
        }
      }
    }
    &-culture{
      background: #F4F6FC;
      padding: 0.9rem;
      &-title{
        width: 2rem;
        height: 0.2rem;
        margin: auto;
        text-align: center;
        background: #E4EBFE;
        font-size: 0.38rem;
        color: #202020;
        display: flex;
        justify-content: center;
        >div{
          margin-top: -0.2rem;
          letter-spacing: 4px;
        }
      }
      &-content{
        display: flex;
        align-items: flex-start;
        justify-content: space-evenly;
        margin-top: 0.96rem;
        >div{
          text-align: center;
          >img{
            width: 2.94rem;
            height: 2.1rem;
          }
          .title{
            font-size: 0.38rem;
            color: #202020;
            margin-bottom: 0.7rem;
          }
          .info{
            width: 3.4rem;
             text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            color: #412D2D;
            font-size: 0.22rem;
          }
        }
      }
    }
    &-advantage{
      margin-top: 0.8rem;
      &-title{
        width: 2rem;
        height: 0.2rem;
        margin: auto;
        text-align: center;
        background: #E4EBFE;
        font-size: 0.38rem;
        color: #202020;
        display: flex;
        justify-content: center;
        >div{
          margin-top: -0.2rem;
          letter-spacing: 4px;
        }
      }
      &-content{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;
        >div{
          cursor: pointer;
          width: 3rem;
          height: 4.5rem;
          padding: 0.4rem;
          box-sizing: border-box;          
          color: #202020;
          text-align: center;
          >div:nth-child(1){
            color: #275CCF;
            font-size: 0.3rem;
          }
          >div:nth-child(2){
            color: #202020;
            font-size: 0.2rem;
            margin-top: 0.5rem;
            text-align: left;
            text-indent: 0.2rem;
          }
        }
        .active{
          background: url('../assets/img/about_advantage.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          >div{
            color: #fff !important;
          }
          
        }
      }
    }
    &-map{
      position: relative;
      width: 100%;
      height: 6.94rem;
      >img{
        width: 100%;
        height: 100%;
      }
      &-location{
        width: 5.5rem;
        height: 0.77rem;
        background:#fff;
        border-radius: 0.12rem;
        display: flex;
        align-items: center;
        position: absolute;
        top: 3.23rem;
        right: 1.5rem;
        font-size: 0.24rem;
        >img{
          margin:0 0.3rem;
        }
      }
    }
  }
</style>0